import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import reportWebVitals from './reportWebVitals';

// One chunk per route: public visitors never download the admin panel (and vice versa)
const App = lazy(() => import('./App'));
const LandingChat = lazy(() => import('./pages/LandingChat'));
const EmbeddableChat = lazy(() => import('./pages/EmbeddableChat'));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const path = window.location.pathname || '/';

const Page = path === '/admin' ? App : path === '/embeber' ? EmbeddableChat : LandingChat;

root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <Page />
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
